import React from 'react';
import { Radio, MessageCircle, Share2, FileText, Scale } from 'lucide-react';

const META = {
  radio: { label: 'Radio', Icon: Radio, color: 'bg-orange-50 text-orange-700 border-orange-200' },
  whatsapp: { label: 'WhatsApp', Icon: MessageCircle, color: 'bg-green-50 text-green-700 border-green-200' },
  social: { label: 'Social', Icon: Share2, color: 'bg-blue-50 text-blue-700 border-blue-200' },
  evidence_brief: { label: 'Evidence Brief', Icon: FileText, color: 'bg-gray-100 text-gray-700 border-gray-200' },
  policy_brief: { label: 'Policy Brief', Icon: Scale, color: 'bg-purple-50 text-purple-700 border-purple-200' },
};

export const ChannelBadges = ({ channels, label = 'Shared on' }) => {
  const list = Array.isArray(channels) ? channels.filter((c) => META[c]) : [];
  if (list.length === 0) return null;
  return (
    <div data-testid="channels-shared" className="flex flex-wrap items-center gap-2">
      <span className="text-xs uppercase tracking-wide font-bold text-gray-500">{label}</span>
      {list.map((c) => {
        const m = META[c];
        const Icon = m.Icon;
        return (
          <span
            key={c}
            data-testid={`channel-badge-${c}`}
            className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border ${m.color}`}
          >
            <Icon className="w-3 h-3" /> {m.label}
          </span>
        );
      })}
    </div>
  );
};

export default ChannelBadges;
